<ng-container>
  <!-- Dealer Group Selection Button -->
  <button
    type="button"
    class="dealer-group__popover-btn btn btn-outline-primary bg-white text-primary"
    #popover="bs-popover"
    [popover]="dealerGroupPopoverContent"
    placement="bottom"
    [adaptivePosition]="false"
    [outsideClick]="true"
    [attr.aria-label]="displayText + ' (' + (totalSelected$ | async) + ' selected)'"
    aria-haspopup="dialog"
    [attr.aria-expanded]="popover.isOpen"
    data-test-id="app-dealer-group-e-dealer-group-button"
    (onShown)="onShown()"
    (onHidden)="saveAndSearch()">

    <span class="dealer-group__popover-btn-text">{{ displayText }}</span>
    <span class="ms-3 me-2 pe-1">({{ totalSelected$ | async }})</span>
    <i
      class="ms-auto allycon-glyph-chevron-down text-primary"
      aria-hidden="true">
    </i>
  </button>

  <!-- Dealer Group Popover Content -->
  <ng-template #dealerGroupPopoverContent>
    <div class="dealer-group__popover" role="dialog">
      <div class="dealer-group__popover-content">
        <div class="dealer-group-popover">
          @if (dealerGroups$ | async; as dealerGroups) {

            <!-- Search Input (Multiple Groups Only) -->
            @if (isSellerAssociatedToMultipleLeadSellerGroup) {
              <div class="form-group mb-3">
                <label
                  for="dealer-group-search"
                  class="text-uppercase d-block mb-2">
                  {{ translations.labelSearch }}
                </label>
                <input
                  id="dealer-group-search"
                  type="text"
                  class="form-control"
                  [placeholder]="''"
                  data-test-id="app-dealer-group-popover-e-search-phrase-text-input"
                  (input)="search($event)" />
              </div>
            }

            <!-- Select All Checkbox (Multiple Groups Only) -->
            @if (isSellerAssociatedToMultipleLeadSellerGroup) {
              <div class="custom-control custom-checkbox customBottomMargin">
                <input
                  id="dealer-group-popover-select-all"
                  type="checkbox"
                  class="custom-control-input"
                  [checked]="allSelected$ | async"
                  data-test-id="app-dealer-group-popover-e-all-groups-checkbox"
                  (change)="toggleAll()" />

                <label
                  for="dealer-group-popover-select-all"
                  class="custom-control-label ms-2">
                  {{ translations.labelAllGroups }}
                </label>
              </div>
            }

            <!-- Dealer Group Sections -->
            <div class="dealer-groups-list" role="group">
              @for (groupUuid of dealerGroups.groupUuids; track groupUuid; let index = $index) {
                <app-dealer-group-selection-section
                  [groupUuid$]="groupUuid"
                  [dealershipGroupCount$]="dealershipGroupCount"
                  [state$]="dealerGroups$"
                  [attr.data-group-index]="index"
                  (selectGroup)="toggleGroup($event)"
                  (selectMember)="toggleMember($event)">
                </app-dealer-group-selection-section>
              }
            </div>
          }
        </div>
      </div>

      <!-- Save Button -->
      <button
        type="button"
        class="btn btn-outline-primary btn-block mt-3"
        data-track-elem="button"
        data-track-name="group - save"
        data-track-trigger="save"
        data-test-id="app-dealer-group-e-save-button"
        [attr.aria-label]="translations.btnSave"
        (click)="saveAndSearch()">
        {{ translations.btnSave }}
      </button>
    </div>
  </ng-template>
</ng-container>

